import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { startsWith, isEmpty, isString } from 'lodash';

const customBaseQuery = async (fetchArgs, api, extraOptions) => {
  const baseUrl = window.LiCompUiConfig.API_BASE_URL;
  const accounts = window.LiCompUiMsalInstance.getAllAccounts();
  const isAuthenticated = !isEmpty(accounts);

  const baseFetchOptions = {
    baseUrl,
    prepareHeaders: async (headers, api) => {
      if (isAuthenticated) {
        const token = await window.LiCompUiMsalInstance.acquireTokenSilent({
          account: accounts[0],
          scopes: window.LiCompUiConfig.adfsScopes
        });
        headers.set('Authorization', `Bearer ${token.accessToken}`);
      }
      return headers;
    },
    responseHandler: async (response) => {
      const contentType = response.headers.get('Content-Type');
      if (contentType?.includes('application/json')) {
        return response.json();
      } else {
        const responseText = await response.text();
        if (startsWith(responseText, '{')) {
          try {
            return JSON.parse(responseText);
          } catch {
            return responseText;
          }
        }
      }
    },
  };

  return fetchBaseQuery(baseFetchOptions)(fetchArgs, api, extraOptions)
}

export const api = createApi({
  reducerPath: 'licompApi',
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
});
